import { render, staticRenderFns } from "./MoreSurvey.vue?vue&type=template&id=368f6cfe&scoped=true"
import script from "./MoreSurvey.vue?vue&type=script&lang=js"
export * from "./MoreSurvey.vue?vue&type=script&lang=js"
import style0 from "./MoreSurvey.vue?vue&type=style&index=0&id=368f6cfe&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "368f6cfe",
  null
  
)

export default component.exports